export default __webpack_public_path__ + "static/media/welcome_veiculos.df0558d3.png";